<template>
  <div>
    <app-input-group
      v-model="dateFormatted"
      :label="label"
      :tooltip="tooltip"
      :disabled="disabled"
      type="text"
      v-mask="'##/##/####'"
      placeholder="MM/dd/yyyy"
      @blur="saveFromInput"
      @keypress.enter="saveFromEnter($event)">

      <template v-slot:tooltipHeader>
        <slot name="tooltipHeader"/>
      </template>

      <template v-slot:tooltipText>
        <slot name="tooltipText"/>
      </template>

    </app-input-group>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    dateValue: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data(vm) {
    return {
      date: '',
      dateFormatted: vm.formatDate(vm.dateValue),
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      if (!date.match(/\d{2}-\d{2}-\d{1,4}/)) {
        return date;
      }

      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      const SHORT_YEAR_LENGTH = 2;
      if (!date) return null;

      if (!date.match(/\d{2}\/\d{2}\/\d{1,4}/)) {
        return date;
      }

      const [month, day] = date.split('/');
      let year = date.split('/')[2];
      if (year.length === SHORT_YEAR_LENGTH) {
        year = `19${year}`;
        this.dateFormatted = `${month}/${day}/${year}`;
        this.$emit('input', this.dateFormatted);
      }
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    saveFromInput() {
      this.$emit('input', this.dateFormatted);
      this.date = this.parseDate(this.dateFormatted);
    },
    saveFromEnter(e) {
      e.target.blur();
    },
  },
  directives: {
    mask,
  },
  watch: {
    dateValue() {
      this.date = this.dateValue;
      if (this.date) {
        this.dateFormatted = this.formatDate(this.date);
      } else {
        this.date = new Date().toISOString().substr(0, 10);
        this.dateFormatted = '';
      }
    },
  },
  mounted() {
    if (this.dateValue) {
      this.dateFormatted = this.formatDate(this.dateValue);
      return;
    }
    this.dateFormatted = this.formatDate(this.date);
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.v-application .v-picker {

  .v-btn__content {
    font-size: 1rem;
  }

  .v-date-picker-header {

    .v-btn--icon .v-icon {
      font-size: 1.6rem;
    }

    .accent--text {
      color: lighten($left-sidebar-color, 30%) !important;
    }
  }

  .v-date-picker-table,
  .v-picker__body {

    .accent--text,
    .primary--text {
      color: $left-sidebar-color !important;
    }

    .accent {
      background-color: $left-sidebar-color !important;
    }
  }
}

</style>
